import Barba from '@barba/core'
import gsap from 'gsap'

export default () => {

    console.log('hello world')

    document.querySelectorAll( "#wpadminbar a" ).forEach( item => item.setAttribute( 'data-barba-prevent', 'self' ) )

    Barba.init({
        // debug: true,
        transitions: [{
            name: 'fade',
  
            leave( { current, next, target } ) {

                return new Promise(resolve => {
                    const timeline = new gsap.timeline({ 
                        onComplete() {
                            current.container.remove() 
                            resolve() 
                        }
                    }) 

                    timeline
                        .to(current.container, {
                            opacity: 0
                        })
                })

            },

            enter( { current, next, target} ) {
                return new Promise(resolve =>{ 
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    })

                    const timeline = new gsap.timeline({ 
                        onComplete() {
                            document.querySelectorAll("#wpadminbar a").forEach(item=>item.setAttribute('data-barba-prevent','self'))
                            resolve()
                        }
                    })

                    timeline
                            .fromTo(next.container, {
                                opacity: 0,
                            }, {
                                opacity: 1,
                            })
                })
            },
          
        }]
    });
}


